import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';

function App() {
  const [telemetry, setTelemetry] = useState({});
  const [logs, setLogs] = useState([]);

  // Load from .env file. If missing, fallback to localhost (useful for dev)
  const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api/telemetry/";
  const LOGS_URL = process.env.REACT_APP_LOGS_URL || "http://127.0.0.1:8000/api/logs/";

  // POLLING LOOP (Fetches Data Every 2 Seconds)
  useEffect(() => {
    const fetchData = () => {
      // A. Fetch Cards Data (Latest State)
      axios.get(API_URL).then(response => {
        const uniqueDevices = {};
        response.data.forEach(item => {
          if (!uniqueDevices[item.imei]) {
            uniqueDevices[item.imei] = item;
          }
        });
        setTelemetry(uniqueDevices);
      }).catch(err => console.error("Cards Error:", err));

      // B. Fetch Running Logs (History)
      axios.get(LOGS_URL).then(response => {
        const formattedLogs = response.data.logs.map(log => ({
          id: log.id,
          time: new Date(log.timestamp).toLocaleTimeString(),
          imei: log.imei,
          // --- THIS IS THE LINE THAT SHOWS LAT/LON ---
          info: `Lat:${Number(log.latitude).toFixed(5)} Lon:${Number(log.longitude).toFixed(5)} | Spd:${log.speed}km/h | ${log.battery_level}mV | ${log.is_charging ? "IGN:ON" : "IGN:OFF"}`
        }));
        setLogs(formattedLogs);
      }).catch(err => console.error("Logs Error:", err));
    };

    fetchData();
    const interval = setInterval(fetchData, 2000);
    return () => clearInterval(interval);
  }, []);

  const deviceList = Object.values(telemetry);

  return (
    <div className="App">
      <header className="header">
        <h1>📡 InteliRide Admin</h1>
        <div className="status-dot online" title="Live Polling Active"></div>
      </header>

      <div className="dashboard-container">

        {/* LEFT: Live Status Cards */}
        <div className="status-panel">
          <h2 style={{ marginTop: 0, color: '#7f8c8d' }}>Active Fleet</h2>
          <div className="card-container">
            {deviceList.length === 0 ? <p>Waiting for data...</p> : deviceList.map((item) => (
              <div key={item.imei} className="card">
                <h3>🚙 {item.imei}</h3>
                <div className="data-row">
                  <span>📍 {Number(item.latitude).toFixed(5)}, {Number(item.longitude).toFixed(5)}</span>
                </div>
                <div className="data-row">
                  <span>🚀 {item.speed} km/h</span>
                  <span style={{
                    color: item.is_charging ? '#2ecc71' : '#e74c3c',
                    fontWeight: 'bold',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    background: item.is_charging ? 'rgba(46, 204, 113, 0.1)' : 'rgba(231, 76, 60, 0.1)'
                  }}>
                    {item.is_charging ? "IGNITION ON" : "IGNITION OFF"}
                  </span>
                </div>
                <div className="data-row">
                  <span>🔋 {item.battery_level} mV</span>
                  <small style={{ color: '#95a5a6' }}>{new Date(item.timestamp).toLocaleTimeString()}</small>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT: Live Running Log */}
        <div className="log-panel">
          <div className="log-header">
            <span>Incoming Packets</span>
            <span style={{ fontSize: '0.8em', opacity: 0.7 }}>Live Sync (2s)</span>
          </div>
          <div className="log-content">
            {logs.length === 0 && <div style={{ padding: '20px', color: '#555', textAlign: 'center' }}>Waiting for DB Sync...</div>}
            {logs.map(log => (
              <div key={log.id} className="log-entry">
                <span className="log-time">[{log.time}]</span>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span><span className="log-imei">{log.imei}</span></span>
                  <span className="log-detail">{log.info}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

export default App;